import moment from 'moment';
import * as React from 'react';
import { Form } from 'react-bootstrap';
import DateTimePicker from 'react-datetime';
import { applyChangeIfDateValid } from '../../../../../../utils/datepicker';
import { formatLocalPreview } from '../utils';

type Props = {
  label: string;
  value: Date | null;
  onChange: (date: Date) => void;
};

// Date input explicitly in UTC/GMT+0: redeem code windows are stored and evaluated in UTC by the backend
const RedeemCodeDateField = ({ label, value, onChange }: Props) => (
  <Form.Group>
    <Form.Label>{label} (UTC/GMT+0)</Form.Label>
    <DateTimePicker
      dateFormat="YYYY-MM-DD"
      timeFormat="HH:mm"
      utc
      onChange={applyChangeIfDateValid((date: moment.Moment) => onChange(date.toDate()))}
      value={value ?? undefined}
    />
    {value && <Form.Text className="text-muted">Local time: {formatLocalPreview(value)}</Form.Text>}
  </Form.Group>
);

export default RedeemCodeDateField;
